import BotoesSalvarExcluir from '@/shared/components/forms/BotoesSalvarExcluir';
import Links from '@/shared/constants/navegacao';
import ModalExcluir from '@/shared/components/modals/ModalExcluir';
import ModalHistorico from '@/modules/system/historico/ModalHistorico';
import { useBreadcrumbActions } from '@/shared/contexts/BreadcrumbActionsContext';
import { CustomToggle } from './accordion';
import { EditadoPorRodape } from '@/shared/components/EditadoPorRodape';
import { Form, Button, Tabs, Tab, Accordion, Card } from 'react-bootstrap';
import { useNavigate, useParams } from 'react-router-dom';
import { ReadHolidayResponseDto, UpdateHolidayDto, ReadComarcaDto } from '@/api.types';
import { SubmitHandler, useForm } from 'react-hook-form';
import { Tabelas } from '@/shared/constants/tables';
import { createHoliday, deleteHoliday, readHoliday, updateHoliday } from './holiday.service';
import { toast } from 'react-toastify';
import { useEffect, useState } from 'react';
import { readComarca } from '@/modules/structure/comarca/comarca.service';
import { GetSetores } from '@/modules/structure/setor/setor.service';

export default function HolidaysEditPage() {
  const { register, handleSubmit, reset } = useForm<ReadHolidayResponseDto>();
  const { setActions } = useBreadcrumbActions();
  const [registro, setRegistro] = useState<ReadHolidayResponseDto>();
  const navigate = useNavigate();
  const params = useParams();

  const [searchDefensorias, setSearchDefensorias] = useState<string>('');
  const [searchNucleos, setSearchNucleos] = useState<string>('');
  const [searchSetores, setSearchSetores] = useState<string>('');
  const [comarcas, setComarcas] = useState<ReadComarcaDto[]>([]);
  const [selectedDefensorias, setSelectedDefensorias] = useState<number[]>([]);
  const [selectedNucleos, setSelectedNucleos] = useState<number[]>([]);
  const [setores, setSetores] = useState<{ id: number; nome: string }[]>([]);
  const [selectedSetores, setSelectedSetores] = useState<number[]>([]);
  const [modaExcluirShow, setModalExcluirShow] = useState(false);
  const [modalHistorico, setModalHistorico] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  const [id, setId] = useState<number>(0);
  const btnSalvar = id > 0 ? 'Salvar' : 'Cadastrar';

  useEffect(() => {
    setActions({
      secondary: { label: 'Novo', href: Links.Calendario_Criar, onClick: () => { } },
      history: { label: 'Histórico', onClick: () => setModalHistorico(true) },
    });
    return () => setActions({});
  }, [setActions]);

  interface ILocal {
    id: number;
    nome: string;
  }

  interface IComarca {
    id: number;
    nome: string;
    prefixo: string | null;
    defensorias: ILocal[];
    nucleos: ILocal[];
  }

  useEffect(() => {
    setId(params.id ? Number(params.id) : 0);
  }, []);

  useEffect(() => {
    readComarca({
      skip: 0,
      take: 9999,
      comDefensorias: true,
      comNucleos: true,
    })
      .then((result) => {
        setComarcas(result[0]);
      })
      .catch((error) => {
        toast.error('Falha ao carregar comarcas: ' + error);
      });
  }, []);

  useEffect(() => {
    // Carrega setores para permitir vincular bloqueios ao local de setor
    GetSetores({ skip: 0, take: 9999, comPredio: true })
      .then((result) => {
        setSetores((result?.objects ?? []).map((s: any) => ({ id: s.id, nome: s.nome })));
      })
      .catch((error) => {
        toast.error('Falha ao carregar setores: ' + error);
      });
  }, []);

  function CarregarRegistro() {
    if (id > 0)
      readHoliday({ id: id, comDefensorias: true, comNucleos: true, comSetores: true } as any)
        .then((result) => {
          const res = result[0][0]

          if (res) {
            const registroFormatado = {
              ...res,
              inicio: res.inicio ? res.inicio.split('T')[0] : '',
              fim: res.fim ? res.fim.split('T')[0] : '',
            };
            reset(registroFormatado);
            setRegistro(res);

            if (res.defensorias) {
              setSelectedDefensorias(res.defensorias.map((defensoria) => defensoria.id));
            }
            if (res.nucleos) {
              setSelectedNucleos(res.nucleos.map((nucleo) => nucleo.id));
            }
            if ((res as any).setores) {
              setSelectedSetores((res as any).setores.map((setor: any) => setor.id));
            }
          }
        })
        .catch((res) => {
          toast.error((res as string) + '');
        });
  }

  useEffect(() => {
    CarregarRegistro();
  }, [id, reset]);

  const onSubmit: SubmitHandler<UpdateHolidayDto | ReadHolidayResponseDto> = (obj, e) => {

    e?.preventDefault();
    setIsLoading(true);
    try {
      const payload = {
        ...obj,
        defensorias: selectedDefensorias.map(a => { return { id: a } }),
        nucleos: selectedNucleos.map(a => { return { id: a } }),
        setores: selectedSetores.map(a => { return { id: a } }),
        id: id
      } as any;

      if (id > 0) {
        updateHoliday(payload)
          .then(() => {
            toast.success('Bloqueio Salvo');
            navigate(`${Links.Calendario_Index}`);
          })
          .catch((error) => toast.error(error.message))
          .finally(() => setIsLoading(false));
      } else {
        setIsLoading(true);
        createHoliday(payload as any)
          .then((createdId) => {
            setId(createdId);
            toast.success('Bloqueio Criado');
            navigate(`${Links.Calendario_Editar}/${createdId}`);
          })
          .catch((res) => {
            toast.error((res as string) + '');
          })
          .finally(() => setIsLoading(false));
      }
    } catch (error) {
      toast.error('Erro ao salvar registro: ' + (error as Error).message);
      setIsLoading(false);
    }
  };

  const handleExcluir = (e: React.MouseEvent<HTMLButtonElement>) => {
    e.preventDefault();

    setModalExcluirShow(false);
    deleteHoliday(id)
      .then(() => {
        toast.success("Bloqueio Removido");
        navigate(`${Links.Calendario_Index}`);
      })
      .catch((res) => {
        toast.error(String(res));
      });
  };

  const handleCheckboxChangeDefensorias = (defensoriaId: number) => {
    setSelectedDefensorias((prev) =>
      prev.includes(defensoriaId)
        ? prev.filter((id) => id !== defensoriaId)
        : [...prev, defensoriaId],
    );
  };

  const handleCheckboxChangeNucleos = (nucleoId: number) => {
    setSelectedNucleos((prev) =>
      prev.includes(nucleoId)
        ? prev.filter((id) => id !== nucleoId)
        : [...prev, nucleoId],
    );
  };

  const handleCheckboxChangeSetores = (setorId: number) => {
    setSelectedSetores((prev) =>
      prev.includes(setorId)
        ? prev.filter((id) => id !== setorId)
        : [...prev, setorId],
    );
  };

  const getDefensorias = (): IComarca[] => {
    if (!comarcas || comarcas.length === 0)
      return [];

    return comarcas
      .filter((comarca) => comarca.defensorias && comarca.defensorias.length > 0)
      .map((comarca) => ({
        id: comarca.id,
        nome: comarca.nome,
        prefixo: comarca.prefixo ?? null,
        defensorias: comarca.defensorias || [],
        nucleos: [] as ILocal[],
      }));
  };

  const getNucleos = (): IComarca[] => {
    if (!comarcas || comarcas.length === 0)
      return [];

    return comarcas
      .filter((comarca) => comarca.nucleos && comarca.nucleos.length > 0)
      .map((comarca) => ({
        id: comarca.id,
        nome: comarca.nome,
        prefixo: comarca.prefixo ?? null,
        defensorias: [] as ILocal[],
        nucleos: comarca.nucleos || [],
      }));
  };

  const handleSelectAllDefensorias = () => {
    const tudo = getDefensorias()
      .flatMap((a) => a.defensorias)
      .map((a) => a.id);
    setSelectedDefensorias(tudo);
  };

  const handleDeselectAllDefensorias = () => {
    setSelectedDefensorias([]);
  };

  const handleSelectAllNucleos = () => {
    const tudo = getNucleos()
      .flatMap((a) => a.nucleos)
      .map((a) => a.id);
    setSelectedNucleos(tudo);
  };

  const handleDeselectAllNucleos = () => {
    setSelectedNucleos([]);
  };

  const handleSelectAllSetores = () => {
    setSelectedSetores(setores.map((s) => s.id));
  };

  const handleDeselectAllSetores = () => {
    setSelectedSetores([]);
  };

  const gridStyle: React.CSSProperties = {
    display: 'grid',
    gridTemplateColumns: 'repeat(3, 1fr)',
    gap: '10px',
    padding: '10px',
    maxHeight: '50vh',
    overflowY: 'auto',
  };

  return (
    <>
      <div className="row">
        <div className="col-12">
          <h3 className="pt-4">Bloqueios</h3>
        </div>
      </div>
      <hr className="pb-2" />

      <form
        onSubmit={(event) => {
          void handleSubmit(onSubmit)(event);
        }}
      >
        <div className="row">
          <div className="mb-3 col-md-4">
            <label htmlFor="nome" className="form-label">
              Nome:
            </label>
            <input
              id="nome"
              type="text"
              className="form-control"
              {...register('nome')}
            />
          </div>

          <div className="mb-3 col-md-3">
            <label htmlFor="inicio" className="form-label">
              Início:
            </label>
            <input id="inicio" type="date" className="form-control" required {...register('inicio')} />
          </div>
          <div className="mb-3 col-md-3">
            <label htmlFor="fim" className="form-label">
              Fim:
            </label>
            <input
              id="fim"
              type="date"
              className="form-control"
              {...register('fim')}
            />
          </div>

          <div className='col-md-2 mt-3'>
            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="geral"
                {...register('geral')}
              />
              <label className="form-check-label" htmlFor="geral">
                Aplicar para todos.
              </label>
            </div>

            <div className="form-check form-switch">
              <input
                className="form-check-input"
                type="checkbox"
                id="repete_anualmente"
                {...register('repete_anualmente')}
              />
              <label className="form-check-label" htmlFor="repete_anualmente">
                Repete anualmente.
              </label>
            </div>
          </div>

          <div className="col-md-12 p-3">
            <div className="card">
              <div className="card-header">
                <h5 className="text-center">Defensorias Vinculadas</h5>
              </div>

              <div className="card-body">
                {id > 0 && (
                  <div>
                    <Tabs defaultActiveKey="defensoria">
                      <Tab eventKey="defensoria" title="Defensorias">
                        <Form.Group className="mb-3">
                          <Form.Control
                            type="text"
                            placeholder="Buscar por nome da defensoria ou comarca..."
                            value={searchDefensorias}
                            onChange={(e) =>
                              setSearchDefensorias(e.target.value)
                            }
                          />
                        </Form.Group>

                        <div className="mb-3">
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={handleSelectAllDefensorias}
                            className="me-2"
                          >
                            Marcar Todos
                          </Button>
                          <Button
                            variant="secondary"
                            size="sm"
                            onClick={handleDeselectAllDefensorias}
                          >
                            Desmarcar Todos
                          </Button>
                        </div>

                        <Accordion defaultActiveKey="0" className="mb-3">
                          {comarcas &&
                            getDefensorias()
                              .filter((comarca: IComarca) =>
                                comarca.defensorias.some(
                                  (d: ILocal) =>
                                    d.nome
                                      .toLowerCase()
                                      .includes(
                                        searchDefensorias.toLowerCase(),
                                      ) ||
                                    comarca.nome
                                      .toLowerCase()
                                      .includes(
                                        searchDefensorias.toLowerCase(),
                                      ),
                                ),
                              )
                              .map((comarca: IComarca, index: number) => (
                                <Card key={`comarca-${comarca.id}`} className="mb-2">
                                  <Card.Header className="p-0">
                                    <CustomToggle eventKey={index.toString()}>
                                      {comarca.prefixo
                                        ? `${comarca.prefixo} - `
                                        : ''}
                                      {comarca.nome}
                                      <span className="badge bg-primary ms-2">
                                        {comarca.defensorias.length}
                                      </span>
                                    </CustomToggle>
                                  </Card.Header>

                                  <Accordion.Collapse
                                    eventKey={index.toString()}
                                  >
                                    <Card.Body className="p-2">
                                      <div style={gridStyle}>
                                        {comarca.defensorias
                                          .filter((defensoria: ILocal) =>
                                            defensoria.nome
                                              .toLowerCase()
                                              .includes(
                                                searchDefensorias.toLowerCase(),
                                              ),
                                          )
                                          .map((defensoria: ILocal) => (
                                            <Form.Check
                                              key={`defensoria-${defensoria.id}`}
                                              id={`defensoria-${defensoria.id}`}
                                              type="checkbox"
                                              label={defensoria.nome}
                                              checked={selectedDefensorias.includes(
                                                defensoria.id,
                                              )}
                                              onChange={() =>
                                                handleCheckboxChangeDefensorias(
                                                  defensoria.id,
                                                )
                                              }
                                              className="mb-1"
                                            />
                                          ))}
                                      </div>
                                    </Card.Body>
                                  </Accordion.Collapse>
                                </Card>
                              ))}
                        </Accordion>
                      </Tab>
                      <Tab eventKey="nucleo" title="Núcleos">
                        <Form.Group className="mb-3">
                          <Form.Control
                            type="text"
                            placeholder="Buscar por nome do núcleo ou comarca..."
                            value={searchNucleos}
                            onChange={(e) =>
                              setSearchNucleos(e.target.value)
                            }
                          />
                        </Form.Group>

                        <div className="mb-3">
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={handleSelectAllNucleos}
                            className="me-2"
                          >
                            Marcar Todos
                          </Button>
                          <Button
                            variant="secondary"
                            size="sm"
                            onClick={handleDeselectAllNucleos}
                          >
                            Desmarcar Todos
                          </Button>
                        </div>

                        <Accordion defaultActiveKey="0" className="mb-3">
                          {comarcas &&
                            getNucleos()
                              .filter((comarca: IComarca) =>
                                comarca.nucleos.some(
                                  (n: ILocal) =>
                                    n.nome
                                      .toLowerCase()
                                      .includes(
                                        searchNucleos.toLowerCase(),
                                      ) ||
                                    comarca.nome
                                      .toLowerCase()
                                      .includes(
                                        searchNucleos.toLowerCase(),
                                      ),
                                ),
                              )
                              .map((comarca: IComarca, index: number) => (
                                <Card key={`comarca-nucleo-${comarca.id}`} className="mb-2">
                                  <Card.Header className="p-0">
                                    <CustomToggle eventKey={`nucleo-${index.toString()}`}>
                                      {comarca.prefixo
                                        ? `${comarca.prefixo} - `
                                        : ''}
                                      {comarca.nome}
                                      <span className="badge bg-primary ms-2">
                                        {comarca.nucleos.length}
                                      </span>
                                    </CustomToggle>
                                  </Card.Header>

                                  <Accordion.Collapse
                                    eventKey={`nucleo-${index.toString()}`}
                                  >
                                    <Card.Body className="p-2">
                                      <div style={gridStyle}>
                                        {comarca.nucleos
                                          .filter((nucleo: ILocal) =>
                                            nucleo.nome
                                              .toLowerCase()
                                              .includes(
                                                searchNucleos.toLowerCase(),
                                              ),
                                          )
                                          .map((nucleo: ILocal) => (
                                            <Form.Check
                                              key={`nucleo-${nucleo.id}`}
                                              id={`nucleo-${nucleo.id}`}
                                              type="checkbox"
                                              label={nucleo.nome}
                                              checked={selectedNucleos.includes(
                                                nucleo.id,
                                              )}
                                              onChange={() =>
                                                handleCheckboxChangeNucleos(
                                                  nucleo.id,
                                                )
                                              }
                                              className="mb-1"
                                            />
                                          ))}
                                      </div>
                                    </Card.Body>
                                  </Accordion.Collapse>
                                </Card>
                              ))}
                        </Accordion>
                      </Tab>
                      <Tab eventKey="setor" title="Setores">
                        <Form.Group className="mb-3">
                          <Form.Control
                            type="text"
                            placeholder="Buscar por nome do setor..."
                            value={searchSetores}
                            onChange={(e) => setSearchSetores(e.target.value)}
                          />
                        </Form.Group>

                        <div className="mb-3">
                          <Button
                            variant="primary"
                            size="sm"
                            onClick={handleSelectAllSetores}
                            className="me-2"
                          >
                            Marcar Todos
                          </Button>
                          <Button
                            variant="secondary"
                            size="sm"
                            onClick={handleDeselectAllSetores}
                          >
                            Desmarcar Todos
                          </Button>
                        </div>

                        <Accordion defaultActiveKey="0" className="mb-3">
                          <Card className="mb-2">
                            <Card.Header className="p-0">
                              <CustomToggle eventKey="setor-0">
                                Setores
                                <span className="badge bg-primary ms-2">
                                  {setores.length}
                                </span>
                              </CustomToggle>
                            </Card.Header>

                            <Accordion.Collapse eventKey="setor-0">
                              <Card.Body className="p-2">
                                <div style={gridStyle}>
                                  {setores
                                    .filter((setor) =>
                                      setor.nome
                                        .toLowerCase()
                                        .includes(searchSetores.toLowerCase()),
                                    )
                                    .map((setor) => (
                                      <Form.Check
                                        key={`setor-${setor.id}`}
                                        id={`setor-${setor.id}`}
                                        type="checkbox"
                                        label={setor.nome}
                                        checked={selectedSetores.includes(setor.id)}
                                        onChange={() =>
                                          handleCheckboxChangeSetores(setor.id)
                                        }
                                        className="mb-1"
                                      />
                                    ))}
                                </div>
                              </Card.Body>
                            </Accordion.Collapse>
                          </Card>
                        </Accordion>
                      </Tab>
                    </Tabs>
                  </div>
                )}
              </div>
            </div>
          </div>
          <EditadoPorRodape dados={{ editadoPor: registro?.editadoPor, editadoEm: registro?.editadoEm }} />
          <div>
            <BotoesSalvarExcluir
              isLoading={isLoading}
              texto={btnSalvar}
              textoLoading={btnSalvar === 'Cadastrar' ? ' Cadastrando...' : ' Salvando...'}
              id={id}
              onExcluirClick={() => setModalExcluirShow(true)}
            />
          </div>
        </div>
      </form>

      <ModalExcluir
        show={modaExcluirShow}
        handleExcluir={handleExcluir}
        handleHide={() => setModalExcluirShow(false)}
      />
      <ModalHistorico
        show={modalHistorico}
        handleHide={() => setModalHistorico(false)}
        tabela={Tabelas.feriado}
        idRegistro={id}
      />
    </>
  );
}
